import { nanoid } from 'nanoid';

import { IWorkBenchLayout } from '@fox/blocks';
import { CREATE_PEOPLE_BLOCK, CREATE_PERSON_BLOCK, TRANSACTION_BLOCK_TYPE } from '../../form-block-types';

import { FormQuestionTypes } from '../blocks/question-block/contracts';
import { prefillStringAnswer } from '../blocks/question-block/question-block';
import { prefillTransactionAnswer } from '../blocks/transaction-block/transaction-block';
import { IQuestionAnswer } from '../form-root/contracts';

function prefillCreatePersonAnswer(query: URLSearchParams, question: any): IQuestionAnswer | undefined {
	const firstName = query.get('firstname');
	const lastName = query.get('lastname');
	const email = query.get('email');
	if (firstName || lastName || email) {
		const userInfo: Record<string, string> = {};
		if (firstName) userInfo.firstName = firstName;
		if (lastName) userInfo.lastName = lastName;
		if (email) userInfo.email = email;

		return {
			questionName: question.name,
			answer: {
				answerJson: JSON.stringify({ contacts: [{ id: nanoid(), ...userInfo }] })
			},
			type: question.type
		};
	}
}

// These are special functions that can prefill answers based on URL query parameters.
// They will take into account the metadata of the question to determine how to prefill it.
const prefillAnswer: Record<string, (query: URLSearchParams, question: any) => IQuestionAnswer | undefined> = {
	[FormQuestionTypes.Text]: prefillStringAnswer,
	[FormQuestionTypes.SingleChoice]: prefillStringAnswer,
	[TRANSACTION_BLOCK_TYPE]: prefillTransactionAnswer,
	[CREATE_PERSON_BLOCK]: prefillCreatePersonAnswer,
	[CREATE_PEOPLE_BLOCK]: prefillCreatePersonAnswer
};

export function prefillAnswers(layout: IWorkBenchLayout) {
	// determine any questions that can be prefilled
	const fields = layout.layouts[0].props.sections.flatMap(s => s.fields);
	// console.log('Fields for prefill:', fields);

	const prefilledAnswers: IQuestionAnswer[] = [];
	const query = new URLSearchParams(window.location.search);
	for (const field of fields) {
		if (prefillAnswer[field.type]) {
			const answer = prefillAnswer[field.type](query, field);
			if (answer) {
				prefilledAnswers.push(answer);
				// console.log('Prefilled answer:', answer);
			}
		}
	}

	return prefilledAnswers.length > 0 ? prefilledAnswers : undefined;
}
